import Icon from 'veui/components/Icon'
import { IconCnyCircle } from 'dls-icons-vue'

Icon.register('cny-circle', IconCnyCircle)
